import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acces-interdit',
  imports: [],
  templateUrl: './acces-interdit.component.html',
  styleUrl: './acces-interdit.component.scss',
})
export class AccesInterditComponent {
  constructor(private readonly router: Router) {}

  protected goBack(): void {
    void this.router.navigateByUrl('/intranet');
  }
}
